import 'unfetch/polyfill/index';
import 'core-js/features/promise';

export default class SciteMetrics {
    constructor() {
        this._classList = this.classList;
        this._selectors = this.selectors;
        this._elements = this.elements;
        this.init();
    }

    get classList() {
        return {
            sciteMetrics: 'scite-metrics',
            loading: 'js--loading',
        };
    }

    get selectors() {
        return {
            sciteMetrics: '.scite-metrics',
            lazyLoad: '.scite-metrics__lazyLoad',
        };
    }

    get elements() {
        return {
            sciteMetrics: null,
            lazyLoad: null,
        };
    }

    setElements() {
        this._elements.sciteMetrics = this.convertToArray(document.querySelectorAll(this._selectors.sciteMetrics));
        this._elements.lazyLoad = this.convertToArray(document.querySelectorAll(this._selectors.lazyLoad));
    }

    onReady() {
        if (this._elements.lazyLoad.length) {
            this._elements.lazyLoad.forEach(item => this.loadWidgetContent(item));
        }
    }

    loadWidgetContent = item => {
        const ajaxUrlData = item.dataset.ajaxUrl;

        if (ajaxUrlData) {
            fetch(ajaxUrlData)
                .then(response => response.text())
                .then(data => (item.innerHTML = data));
        }
    };

    init() {
        this.setElements();
        this.onReady();
    }

    convertToArray = nodeList => Array.prototype.slice.call(nodeList);
}
